/*
 * Copyright (c) 2021 JCA Electronics , Winnipeg, MB. All rights reserved.
 */

import { deserialize, deserializeArray, serialize } from 'class-transformer';
import { DeployedSinglePathMissionCloudState } from './enums/DeployedSinglePathMissionCloudState';
import { MachineKey } from './MachineKey';

export class DeployedSinglePathMissionSummary {
  MissionID!: string;
  MissionName!: string;
  MissionDeploymentID!: string;
  TargetMachine!: MachineKey;
  MissionState!: DeployedSinglePathMissionCloudState;
  DeployerUserID!: string;
  DeployedTimeUTC!: Date;
  UpdateTimeUTC!: Date;
  JobID!: string;
  ReferenceFieldID!: string;
  ReferencePathID!: string;
  ApplicationParameters!: string;

  static toModel(json: string): DeployedSinglePathMissionSummary {
    const obj = deserialize(DeployedSinglePathMissionSummary, json);
    return obj;
  }

  static toModelCollection(json: string): DeployedSinglePathMissionSummary[] {
    const objCollection = deserializeArray(DeployedSinglePathMissionSummary, json);
    return objCollection;
  }

  fromModelToJson(): string {
    const jsObj = serialize(this);
    return jsObj;
  }
}
